import * as React from 'react';
import {ChecklistSummary, ClientSummary, RentalItem, Returnal} from '../api/dtos/dtos';
import ReturnItemsEditor from './ReturnItemsEditor';
import locales from '../locales';
import ReturnalForm from './ReturnalForm';
import {EditorMode} from '../common/types';
import ErrorFormItem from "../common/form-items/ErrorFormItem";

interface ReturnDetailsEditorProps {
  mode: EditorMode;
  editable: boolean;
  returnal?: Returnal;
  checklistSummary?: ChecklistSummary;
  onReturnalChange: (returnal: Returnal) => void;
  onSubmit: () => void;
  onCancel: () => void;
  showChecklist: boolean;
  onChecklistAdd?: (rentalItemId: number) => void;
  onChecklistEdit?: (checklistId: number) => void;
}

interface ReturnDetailsEditorState {
  missingRentalItemsErrorVisible: boolean;
}

class ReturnDetailsEditor extends React.Component<ReturnDetailsEditorProps, ReturnDetailsEditorState> {

  public state: ReturnDetailsEditorState = {
    missingRentalItemsErrorVisible: false,
  };

  public render(): React.ReactNode {
    const {
      returnal,
      editable,
      onReturnalChange,
      mode,
      showChecklist,
      checklistSummary,
    } = this.props;
    const rentalItems = returnal ? returnal.rentalItems ? returnal.rentalItems : [] : [];
    const {missingRentalItemsErrorVisible} = this.state;

    const client = this.getClient();
    const clientId = client ? client.id : null;

    return (
      <>
        <ReturnalForm
          mode={mode}
          editable={editable}
          returnal={returnal}
          onReturnalChange={onReturnalChange}
          onFormCancel={this.onFormCancel}
          onFormSubmit={this.onFormSubmit}
        >

          <ReturnItemsEditor
            mode={mode}
            clientId={clientId}
            editable={this.isItemEditorEditable()}
            rentalItems={rentalItems}
            onRentalItemsChange={this.onRentalItemsChange}
            showChecklist={showChecklist}
            checklistSummary={checklistSummary}
            onChecklistAdd={this.props.onChecklistAdd}
            onChecklistEdit={this.props.onChecklistEdit}
          />

          {missingRentalItemsErrorVisible && <ErrorFormItem message={locales.item_mandatory}/>}
        </ReturnalForm>
      </>
    );
  }

  private getClient = (): ClientSummary | undefined => {
    return this.props.returnal ? this.props.returnal.client : undefined;
  };

  private isItemEditorEditable = (): boolean => {
    return this.props.editable && this.getClient() !== undefined;
  };

  private onFormSubmit = () => {
    const {returnal, onSubmit} = this.props;
    const rentalItems = returnal ? returnal.rentalItems : [];

    if (!rentalItems || rentalItems.length === 0) {
      this.setMissingRentalItemsErrorVisible(true);
      return;
    }
    onSubmit();
  };

  private setMissingRentalItemsErrorVisible = (visible: boolean) => {
    this.setState({
      missingRentalItemsErrorVisible: visible,
    })
  };

  private onFormCancel = () => {
    this.props.onCancel();
  };

  private onRentalItemsChange = (rentalItems: RentalItem[]) => {
    this.setState({
      missingRentalItemsErrorVisible: rentalItems.length === 0,
    });
    const {returnal, onReturnalChange} = this.props;
    onReturnalChange({
      ...returnal,
      rentalItems: [...rentalItems],
    });
  };

}

export default ReturnDetailsEditor;


// WEBPACK FOOTER //
// ./src/return-details/ReturnDetailsEditor.tsx